import React, { useState } from 'react';
import { Box, HStack } from '@chakra-ui/react';

interface PhotoGalleryProps {
  images: string[];
  width?: string;
  height?: string;
  indicatorTop?: string;
  indicatorLeft?: string;
  onImageChange?: (index: number) => void;
  initialIndex?: number;
  borderRadius?: string;
}

const PhotoGallery: React.FC<PhotoGalleryProps> = ({
  images,
  width = '375px',
  height = '296px',
  indicatorTop = '266px',
  indicatorLeft = '24px',
  onImageChange,
  initialIndex = 0,
  borderRadius
}) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(initialIndex);

  const handleImageChange = (index: number) => {
    setCurrentImageIndex(index);
    if (onImageChange) {
      onImageChange(index);
    }
  };

  const handleImageClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    
    const rect = e.currentTarget.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const imageWidth = rect.width;
    const leftSideWidth = imageWidth / 4;
    const rightSideWidth = imageWidth * 3 / 4;

    if (clickX < leftSideWidth) {
      // Click on left side - go to previous image
      const newIndex = currentImageIndex === 0 ? images.length - 1 : currentImageIndex - 1;
      handleImageChange(newIndex);
    } else if (clickX > rightSideWidth) {
      // Click on right side - go to next image
      const newIndex = currentImageIndex === images.length - 1 ? 0 : currentImageIndex + 1;
      handleImageChange(newIndex);
    }
  };

  return (
    <>
      {/* Background Image */}
      <Box
        position="absolute"
        top="0"
        left="0"
        width={width}
        height={height}
        backgroundImage={`url(${images[currentImageIndex]})`}
        backgroundSize="cover"
        backgroundPosition="center"
        borderRadius={borderRadius}
        overflow="hidden"
        zIndex={0}
        cursor="pointer"
        onClick={handleImageClick}
      />

      {/* Page Indicators */}
      <HStack
        position="absolute"
        left={indicatorLeft}
        top={indicatorTop}
        spacing="2px"
        zIndex={1}
      >
        {images.map((_, index) => (
          <Box
            key={index}
            width="7px"
            height="7px"
            backgroundColor={index === currentImageIndex ? "#C6D959" : "#1C1C1E"}
            borderRadius="3.5px"
            cursor="pointer"
            onClick={(e) => {
              e.stopPropagation();
              handleImageChange(index);
            }}
            _hover={{
              backgroundColor: index === currentImageIndex ? "#C6D959" : "#4A4A4A"
            }}
            transition="background-color 0.2s ease-in-out"
          />
        ))}
      </HStack>
    </>
  );
};

export default PhotoGallery;
